import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class auctionsListViewCtrl implements IController {

  delivery: any;

  private auctionRef: any;
  private auctions: any;
  private loading: any;

  /* @ngInject */
  constructor(private $auction, private AuctionsAPI, private $log, private $scope: IScope) {
  }

  $onInit() {
    this.auctionRef = this.$auction();
    this.auctions = [];

    this.getAuctions(this.delivery.id);

    this.auctionRef.$onCreate(this.$scope, (auctions) => {
      this.$log.info(auctions);
      if (auctions) {
        _.forEach(auctions, (auction) => {
          if (_.isEqual(auction.dlvid, this.delivery.id)) {
            const auctionIndex = _.findIndex(this.auctions, (singleAuction) => {
              return _.isEqual(_.get(singleAuction, 'id'), auction.id);
            });
            if (_.isEqual(auctionIndex, -1)) {
              this.auctions.unshift(auction);
            }
          }
        })
      }
    });
  }

  getAuctions(_id) {
    this.loading = true;
    this.$auction().$call(this.AuctionsAPI.actions.getDeliveryAuctions, {dlvid: _id}, null, null, true)
      .then((_auctions) => {
        _.set(this, 'auctions', _auctions);
      })
      .finally(() => {
        this.loading = false;
      })
  }

}

angular
  .module('bringoz.admin.auctions')
  .component('auctionsListView', {
    bindings: {
      delivery: '='
    },
    template: require('./auctions-list-view.html').default,
    controller: auctionsListViewCtrl
  });
